export const en = {
  pwa: {
    update: "Update",
    updateDescription: "A new app update has been detected",
    updateTitle: "Update available",
  },
};
